"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumGliederResolver = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
const ConfigurationUnion_1 = require("../ConfigurationUnion");
class NumGliederResolver {
    /**
     * resolves the total amount of links for the given configuration
     */
    static resolve(configuration) {
        const { type, config } = (0, ConfigurationUnion_1.asTypedConfigurationUnion)(configuration);
        switch (type) {
            case 'Kette':
            case 'EspoolChild':
                return config.Kette.NumGlieder;
            case 'Espool':
                return undefined; // not supported yet (but could be sum of all links)
            case 'Empty':
                return undefined;
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(config);
        }
    }
    /**
     * resolves the amount of links for the given configuration which can be used for filling
     */
    static resolveUsable(configuration) {
        const { type, config } = (0, ConfigurationUnion_1.asTypedConfigurationUnion)(configuration);
        switch (type) {
            case 'Kette':
            case 'EspoolChild': {
                const ketteModel = config.Kette;
                const numGlieder = ketteModel.NumGlieder;
                if (numGlieder != null && config.Kette.Halbstegig) {
                    if ((0, echain_shared_articles_1.findKettenSystemGroup)(ketteModel) === echain_shared_articles_1.KettenSystemGroup.HALBSTEGIG_E4_1_OR_E4_00) {
                        return Math.ceil(numGlieder / 2);
                    }
                    return Math.floor(numGlieder / 2);
                }
                return numGlieder;
            }
            case 'Espool':
                return undefined; // not supported yet (but could be sum of all links)
            case 'Empty':
                return undefined;
            default:
                (0, echain_shared_ts_utils_1.assertUnreachable)(config);
        }
    }
}
exports.NumGliederResolver = NumGliederResolver;
NumGliederResolver.className = 'NumGliederResolver';
//# sourceMappingURL=NumGlieder.resolver.js.map